import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import EnhancedSearch from './EnhancedSearch';
import './Hero.css';

const Hero = () => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const [showEnhancedSearch, setShowEnhancedSearch] = useState(false);

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      const searchParams = new URLSearchParams();
      searchParams.append('search', searchQuery.trim());
      navigate(`/talent-search?${searchParams.toString()}`);
    }
  };

  return (
    <>
      {/* Main Hero Section - Clean and Focused */}
      <section className="hero-main">
        <div className="container">
          <div className="hero-content-wrapper">
            {/* Main Search Form - Above Title */}
            <form onSubmit={handleSearch} className="hero-search-form">
              <div className="hero-search-container">
                <div className="hero-search-field">
                  <span className="hero-search-icon">
                    <i className="bi bi-search"></i>
                  </span>
                  <input
                    type="text"
                    placeholder="Search for jobs, skills, or talent..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    className="hero-search-input"
                  />
                </div>
                <button type="submit" className="hero-search-button">
                  Search
                </button>
              </div>
            </form>

            <h1 className="hero-main-title">
              Your Personal Career Copilot
            </h1>
            <p className="hero-main-subtitle">
              Discover opportunities, connect with top talent, and take the next step in your career journey
            </p>

            {/* Quick Actions */}
            <div className="hero-quick-actions">
              <button 
                className="hero-action-btn primary"
                onClick={() => navigate('/vacancies')}
              >
                Find Jobs
              </button>
              <button 
                className="hero-action-btn secondary"
                onClick={() => setShowEnhancedSearch(true)}
              >
                Browse Talent
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Enhanced Search Modal */}
      <EnhancedSearch 
        isOpen={showEnhancedSearch}
        onClose={() => setShowEnhancedSearch(false)}
      />
    </>
  );
};

export default Hero;
